<my-header></my-header>
<div class="paymentConfirm" #content id="pdfDownload">
    <app-banner></app-banner>
     <!-- <app-signature-capture 
    *ngIf="paymentSuccess && !signatureDone" 
    (isSignatureApplyied)="signatureCheck($event)" [CopayValue]="true">
  </app-signature-capture> -->
    <div class="payment-order">
        <div *ngIf="paymentSuccess" class="title">Payment Confirmation</div>
        <div   *ngIf="!paymentSuccess"  class="title">Confirmation</div>
        <div class="payment-list" *ngIf="!isError" #paymentList>
            <div class="payment-succ"><img src="/assets/images/Payment-Scuess-loop2.gif" /></div>
            <div class="payment-out">
                <div class="text item--1">
                    <span>Transaction Successful!!</span>
                </div>
                <div class="text item--2">
                    <span *ngIf="paymentSuccess">Thank you! Your payment has been processed successfully.</span>
                    <span>Wishing you an excellent health and well being.</span>
                </div>
                <div class="item item--3">
                    <span>Date & Time:</span>
                    <span>{{todayDate}}</span>
                </div>
                <div class="item item--4">
                    <span>Transaction ID#:</span>
                    <span>{{selectedTransId ? (selectedTransId) : '-'}}</span>
                </div>
                <div class="item item--5" *ngIf="paymentSuccess">
                    <span>Card Type:</span>
                    <span>{{ transDetails?.CardLogo ? transDetails?.CardLogo : (transDetails?.cardType ? transDetails?.cardType : '-') }}</span>
                </div>
                <div class="item item--6" *ngIf="paymentSuccess">
                    <span>Last 4 digits on card:</span>
                    <span>{{ transDetails?.LastFour ? transDetails?.LastFour : (transDetails?.last4 ? transDetails?.last4 : '-') }}</span>
                </div>
                <div class="item item--7" *ngIf="paymentSuccess">
                    <span>Authorization#:</span>
                    <span>{{ approvalNum ? approvalNum : (transDetails?.ApprovalNumber ? transDetails?.ApprovalNumber : '-') }}</span>
                </div>
                <div class="item item--8">
                    <span>Amount Paid:</span>
                    <span>{{transactionAmt ? (transactionAmt | currency) : (transDetails?.AmountDue ? (transDetails?.AmountDue | currency): "$0.00")}}</span>
                </div>
                <div class="payments">
                    <div class="pay-btns">
                        <button type="button" class="pay-now" (click)="downloadReceipt()">Print Receipt</button>
                        <button type="button" class="cancel" (click)="goToPendingPaymentsList()">Close</button>
                    </div>
                </div>
            </div>
        </div>
<div class="page-wrapper" *ngIf="isError">
  <div class="top">
    <div class="error-box">
        <img class="icon cross_icon_size" src="/assets/images/fail.svg" alt="Selected" />
      <h2 class="font_size_16">Transaction Failure!!</h2>
      <p class="font_fam">Something went wrong while processing your payment.<br/>Try again in a few moments.</p>
    </div>
  </div>

  <button class="retry-btn" (click)="retryPayment()">Retry Payment</button>
</div>

    </div>
</div>
